import { PropsWithChildren } from 'react';

export function Container({ children }: PropsWithChildren<unknown>) {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      {/* Used 27% to match the size of the old bootstrap layout; max-width caps the login box on wider viewports */}
      <div className="w-full sm:w-[27%] sm:max-w-[410px]">{children}</div>
    </div>
  );
}
